module.exports = __webpack_public_path__ + "img/ex2.2819bb98.jpg";